export default __webpack_public_path__ + "static/media/rightArrow.41d41add.svg";